import React from 'react';
import PropTypes from 'prop-types';
import ProjectImage from '../../../project-image';

const ImageSegment = ({ segment }) => (
  <div className="segment segment-image">
    <ProjectImage
      block={segment}
      size="full"
      imageProps={{
        width: '100%',
        height: '100%',
      }}
    />
  </div>
);

ImageSegment.propTypes = {
  segment: PropTypes.object.isRequired,
};

export default ImageSegment;



// WEBPACK FOOTER //
// ./src/components/blocks/double/segment/image.js